import Loadingnew from './Loadingnew'
export default Loadingnew;
